import { FC, useMemo } from "react";
import { useTranslation } from "react-i18next";

import {
  sumDistanceCacheMetrics,
  sumRouteCacheMetrics,
  TMetrics,
} from "@ryde/shared";

interface IProductionLogsStatsTabsMetricsCache {
  metrics?: Partial<TMetrics>;
}

export const ProductionLogsStatsTabsMetricsCache: FC<
  IProductionLogsStatsTabsMetricsCache
> = ({ metrics }) => {
  const { t } = useTranslation();
  const { cacheSum, totalSum, cachePercent } = useMemo(
    () => sumRouteCacheMetrics(metrics),
    [metrics],
  );
  const { cachePercent: distanceCachePercent, totalSum: distanceTotalSum } =
    useMemo(() => sumDistanceCacheMetrics(metrics), [metrics]);

  if (!totalSum && !distanceTotalSum) {
    return null;
  }

  return (
    <div className="log__metrics-section">
      <div className="log__metrics-section-title">
        {t("mapCacheStat.metrics.cacheUsageTitle")}
      </div>
      <div className="log__metrics-map-stats">
        {!!totalSum && (
          <>
            <div className="log__metrics-map-item">
              <span className="log__metrics-map-label">
                {t("mapCacheStat.metrics.getRouteCacheSum")}:
              </span>
              <span className="log__metrics-map-value">{cacheSum}</span>
            </div>
            <div className="log__metrics-map-item">
              <span className="log__metrics-map-label">
                {t("mapCacheStat.metrics.getRouteTotalSum")}:
              </span>
              <span className="log__metrics-map-value">{totalSum}</span>
            </div>
          </>
        )}
        {typeof metrics?.getRouteOsrmFirstFlowCalls === "number" && (
          <div className="log__metrics-map-item">
            <span className="log__metrics-map-label">
              {t("mapCacheStat.metrics.getRouteOsrmFirstFlowCalls")}:
            </span>
            <span className="log__metrics-map-value">
              {metrics.getRouteOsrmFirstFlowCalls}
            </span>
          </div>
        )}
        {typeof metrics?.getRouteNonOsrmFirstFlowCalls === "number" && (
          <div className="log__metrics-map-item">
            <span className="log__metrics-map-label">
              {t("mapCacheStat.metrics.getRouteNonOsrmFirstFlowCalls")}:
            </span>
            <span className="log__metrics-map-value">
              {metrics.getRouteNonOsrmFirstFlowCalls}
            </span>
          </div>
        )}
        {!!totalSum && (
          <div className="log__metrics-map-item">
            <span className="log__metrics-map-label">
              {t("mapCacheStat.metrics.cacheUsagePercent")}:
            </span>
            <span className="log__metrics-map-value">{cachePercent}%</span>
          </div>
        )}
        {!!distanceTotalSum && (
          <div className="log__metrics-map-item">
            <span className="log__metrics-map-label">
              {t("mapCacheStat.metrics.distanceCacheUsagePercent")}:
            </span>
            <span className="log__metrics-map-value">
              {distanceCachePercent}%
            </span>
          </div>
        )}
      </div>
    </div>
  );
};
